module.exports = "/images/footer-logo-ifrc.svg?1b97f7cc0d640c6d5dc840a747dffddf";